import React, { useState, useEffect, useContext, Fragment } from "react";
import process from "../../images/process.svg";
import settingw from "../../images/setting-white.svg";
import info from "../../images/info.svg";
import tickgreen from "../../images/tick-green.svg";
import closeImg from "../../images/close.svg";
import { Link, useLocation } from "react-router-dom";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { calculatePriceOfCertifications, miliMeterToInchFactor, processType } from "../../utils/constant";
import { Modal as AntModal } from "antd";
import moment from "moment";
import {
  fetchQuoteById,
  getAllAddress,
  deleteAddress,
  getProfileDetails,
  fetchQuoteByIdForQuoteVersion,
  shareQuoteToEmails,
} from "../../utils/actions/allactions";
import Header from "../../components/Header/header";
import jwt_decode from "jwt-decode";
import AddressModal from "../../components/AddressModal/AddressModal";
import AddressList from "../../components/AddressModal/AddressList";
import shareico from "../../images/share.svg";
import ChatButton from "../../Chat/ChatButton";
import PhoneInput from "react-phone-input-2";
import Chat from "../../Chat";
import { ChatRefContext } from "../../context/chatRef.context";
import { currencyFormatter, getUserIdFromLocalStorage } from "../../utils/helper";
import { Loading } from "../../components/Loading";
import {
  CircleAlertDFM,
  DeleteIcon,
  EditIcon,
  InfoIcon,
  ShareIcon,
} from "../../components/Icons";
import TailwindModalComponent from "../../components/TailwindModalComponent/TailwindModelComponent";
import { checkGenericUser, getUserComapnyInfo, markDefaultAddress } from "../../utils/actions/userActions";
import { updateMobileNumber } from "../../api/customer/master/userMasterApi";
import { useInstance } from "../../context/instance.context";
import GenericAddressComponent from "../../components/GenericAddressComponent/GenericAddressComponent";
import { addBillingAddress, deleteBillingAddress, getBillingAddressById, getCountry, getUserBillingAddressByUserId, updateBillingAddress } from "../../api/customer/masters/commonMastersApi";
import GenericAddressListComponent from "../../components/GenericAddressComponent/GenericAddressListComponent";
import useDocumentTitle from "../../utils/useDocumentTitle";

const StepThree = () => {
  const { setSelectedChatRefId } = useContext(ChatRefContext);
  const navigate = useNavigate();
  let params = useParams();
  let location = useLocation();
  const { name, allInstanceData } = useInstance();
  const is8xParts = allInstanceData?._8xPart == name;
  let fName = localStorage.getItem("firstName");
  let lName = localStorage.getItem("lastName");
  let usrEmail = localStorage.getItem("email");
  let [check, setCheck] = useState(false);
  const [showA, setShowA] = React.useState(false);
  const handleOneClose = () => setShowA(false);
  const [showTwo, setTwoShow] = React.useState(false);
  const handleTwoClose = () => setTwoShow(false);
  const [saveQuote, setSaveQuote] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let _id = params._id;
  const [open, setOpen] = useState(false);
  let loggedInUserEmail = localStorage.getItem("email");
  let userId = localStorage.getItem("_id");
  const [recentAddress, setRecentAddress] = useState([]);
  const [allAddresses, setAllAddresses] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [showAddressList, setShowAddressList] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [fetchedQuoteDetails, setFetchedQuoteDetails] = useState();
  const [shareQuoteModalShow, setShareQuoteModalShow] = useState(false);
  const [emailToShareQuote, setEmailToShareQuote] = useState(
    new Set([])
  );
  const [userCompanyData, setUserCompanyData] = useState(null);
  const [shippingChargeBasedOnSelectedShipMethod, setShippingChargeBasedOnSelectedShipMethod] = useState(0);
  const [certificationsCostBasedOnSelectedShipMethod, setCertificationsCostBasedOnShipMethod] = useState(0);
  const [allBillingAddress, setAllBillingAddress] = useState([]);
  const [reload, setReload] = useState(false);
  const [showGenericAddressModal, setShowGenericAddressModal] = useState(false);
  const [editBillingAddressId, seteditBillingAddressId] = useState(false);
  const [recentBillingAddress, setRecentBillingAddress] = useState([]);
  const [showGenericAddressListModal, setShowGenericAddressListModal] = useState(false);
  const [userCountry, setUserCountry] = useState('');
  useEffect(() => {
    (async () => {
      try {
        const { country } = await getCountry();
        console.log("Comming Country :", country);
        setUserCountry(country);

      } catch (error) {
        console.log("Error while fetching country :", error);
      }
    })()

  }, []);




  useEffect(() => {
    (async () => {
      getUserBillingAddressByUserId(getUserIdFromLocalStorage()).then((res) => {
        if (res.success) {
          setAllBillingAddress(res.billingAddress);
          const firstAddress = res.billingAddress[0];
          if (firstAddress?._id) {
            setValues((values) => ({
              ...values,
              billingAddress: firstAddress?._id,
            }))
          }
          else {
            setValues((values) => ({
              ...values,
              billingAddress: "",
            }))
            setRecentBillingAddress([]);
          };
          const lastTwo = [];
          if (firstAddress) {
            lastTwo.push(firstAddress);
          }
          const secondAddress = res.billingAddress?.find((item) => item?._id != firstAddress?._id);
          if (secondAddress) {
            lastTwo.push(secondAddress);
          }
          setRecentBillingAddress(lastTwo);


        }
      }).catch(Error);

    })()

  }, [reload]);


  useEffect(() => {
    const isUserLoggedIn = localStorage.getItem("isLoggedIn")
    const userId = localStorage.getItem("_id");
    if (isUserLoggedIn && userId) {
      (async () => {
        try {

          const response = await getUserComapnyInfo(userId);
          console.log("Response :", response);
          if (!response || !response.success) {
            throw new Error();
          };

          const { payload: { companySiteId } } = response;

          console.log("User Company Data :", companySiteId);

          setUserCompanyData(companySiteId);


        } catch (error) {
          // toast.error("Error While Fetching Company Info ");
        }
      })()
    }
  }, []);

  console.log("Subtotal :", subTotal);

  console.log("Tax :", tax, typeof tax);
  console.log("Shipping Charge :", shippingChargeBasedOnSelectedShipMethod, typeof shippingChargeBasedOnSelectedShipMethod);
  console.log("Certifications Cost :", certificationsCostBasedOnSelectedShipMethod, typeof certificationsCostBasedOnSelectedShipMethod);

  const handleSeeAllAddressClick = () => {
    setShowGenericAddressListModal(true);
    setShowGenericAddressModal(false);
  };
  const [isDeleteAddressModalOpen, setDeleteAddressModalOpen] = useState(false);

  const [inputEmail, setInputEmail] = useState("");
  let token = localStorage.getItem("Token");
  let profileDetails = localStorage.getItem("profileDetails");
  profileDetails = JSON.parse(profileDetails);
  const [values, setValues] = useState({
    firstName: fName,
    lastName: lName,
    email: usrEmail,
    mobileNumber: "",
    companyName: "",
    vatNumber: "",
    addressline1: "",
    addressline2: "",
    zipCode: "",
    city: "",
    state: "",
    country: is8xParts ? "US" : "Ireland",
    tax: 0,
    subTotal: 0,
    quoteId: "",
    industry: [],
  });
  const [profileData, setProfileData] = useState({});
  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    companyName: "",
    vatNumber: "",
    addresses: "",
    finalTotalPrice: "",
    addressline1: "",
    addressline2: "",
    zipCode: "",
    city: "",
    state: "",
    country: "US",
    subTotal: "",
  });

  let mailformat =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


  useEffect(() => {
    // Handle the browser back button press
    const handleBackButton = (event) => {
      event.preventDefault();
    };

    // Add event listener for popstate (which is triggered on back button)
    window.addEventListener('popstate', handleBackButton);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);
  const [isGenericUser, setIsGenericUser] = useState(true);
  const [shareQuoteError, setShareQuoteError] = useState(false);
  useEffect(() => {
    if (emailToShareQuote instanceof Set && isGenericUser) {
      emailToShareQuote.forEach((email) => {
        const reciverDomain = email.substring(email.indexOf("@") + 1);
        const loggedInUserDomain = loggedInUserEmail.substring(loggedInUserEmail.indexOf("@") + 1);
        if (reciverDomain != loggedInUserDomain) {
          setShareQuoteError("You are trying to share this quote with recipients from different companies");
        }
      });
    }
    if (emailToShareQuote.size === 0) {
      setShareQuoteError("");
    }
  }, [emailToShareQuote, isGenericUser]);
  useEffect(() => {

    (async () => {
      try {
        const id = localStorage.getItem("_id");
        const response = await checkGenericUser(id);
        if (response.success) {
          const { isGeneric } = response;
          setIsGenericUser(isGeneric);
        }
      } catch (error) {


      }
    })()

  }, []);

  const showDrawer = () => {
    setOpen(true);
    setSelectedChatRefId(fetchedQuoteDetails?.RefId);

  };
  const onClose = () => {
    setOpen(false);
    setSelectedChatRefId(null);
  };

  const addNewHandler = () => {
    setShowAddressModal(true);
  };
  const showAddressListHandler = () => {
    setShowAddressList(true);
  };
  const editHandler = (id) => {
    setShowAddressModal(true);
    setIsEdit(true);
    setEditId(id);
  };
  const deleteData = async (_id) => {
    try {
      if (values.shippingAddress == _id) {
        setValues({ ...values, shippingAddress: "" });
      }
      const payload = {
        _id,
      };
      let response = await deleteAddress({ payload }, token);
      const newData = recentAddress.filter((address, index) => {
        return address._id !== _id;
      });
      setRecentAddress(newData);
      fetchData();

      if (response.data.status == false) {
        toast.error("Something went wrong");
      } else if (response.data.status == true) {
        toast.success("Address deleted successfully");
      }
    } catch (error) {
      console.log(
        "error in step 3 on 186" +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a a"),
        error
      );
    }
  };

  const handleShareQuoteModalOpen = () => {
    setShareQuoteModalShow(true);
  };

  const handleShareQuoteClose = () => {
    setShareQuoteModalShow(false);
  };

  const handleQuotationShare = async () => {
    try {
      if (emailToShareQuote.size === 0) {
        toast.error(
          "Please enter atleast one mail to share the quotation details"
        );
        return;
      } else {

        let data = {
          quoteId: fetchedQuoteDetails._id,
          selectedShipMethod: fetchedQuoteDetails.selectedShipMethod,
          emailToShareQuote: [...emailToShareQuote],
        };
        let token = localStorage.getItem("Token");
        let response = await shareQuoteToEmails(token, data);
        if (response.statusCode == 200) {
          setShareQuoteModalShow(false);
          setEmailToShareQuote(new Set([]));
          toast.success("Quotation details shared successfully");
        } else {
          toast.error("Something went wrong while sharing the quote details.");
        }
      }
    } catch (err) {
      toast.error("Something went wrong.Please try again later.");
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleAddButtonToReceiverList = () => {
    let response = validateEmail(inputEmail);
    if (response) {
      if (emailToShareQuote.has(inputEmail)) {
        toast.error("Email already added to receivers list");
      } else {
        let localEmailList = new Set(emailToShareQuote);
        localEmailList.add(inputEmail);
        setEmailToShareQuote(localEmailList);
        setInputEmail("");
      }
    } else {
      toast.error("Please enter a valid email");
    }
  };
  const addBillingAddressFunction = async (data) => {
    try {
      const response = await addBillingAddress({ ...data, userId });
      if (response.success) {
        toast.success("Billing address added successfully");
        setShowGenericAddressModal(false);
        setReload((pre) => !pre);

      };

    } catch (error) {
      throw new Error('unable to add billing address');
    }


  };

  const getBillingAddressByid = async (id) => {
    try {
      const data = await getBillingAddressById(id);
      if (data.success) {
        return data?.billingAddress || null;
      }
    } catch (error) {

    }
  };
  const billingAddressUpdateFunction = async (id, data) => {
    try {
      const response = await updateBillingAddress(id, data);
      if (response.success) {
        toast.success("Billing address updated successfully");
        setShowGenericAddressModal(false);
        setReload((pre) => !pre);
      };
    }
    catch (error) {
      throw new Error('unable to update billing address');
    }

  }
  const deleteBilllingAddress = async (id) => {
    try {
      if (id) {
        const response = await deleteBillingAddress(id);
        if (response.success) {
          toast.success("Billing address deleted successfully");
          setReload((pre) => !pre);

        }

      }


    } catch (error) {
      console.log("Error in profile  211 on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        error
      );
    }

  }


  const handleSubmit = async () => {
    try {
      if (
        !values.shippingAddress || !values.billingAddress
      ) {
        setError({
          ...error,
          shippingAddress: !values.shippingAddress
            ? "Please select an shipping address."
            : "",
          billingAddress: !values.billingAddress
            ? "Please select an billing address."
            : "",
        });

        if (!values.mobileNumber) {
          toast.error("Please enter valid mobile number");
        }
        else if (!values?.shippingAddress || !values.billingAddress) {
          toast.error("Please select both a shipping address and a billing address to create your order.");
        }
        window.scrollTo({
          top: 100,
          behavior: "smooth",
        })
        return false;
      } else {
        console.log("Values :", values);
        const addressId = values?.shippingAddress;
        await markDefaultAddress(token, addressId, userId);
        const payload = {
          number: values?.mobileNumber,
          userId: values?.userId,
        }
        await updateMobileNumber(payload);
        navigate("/payments/" + _id, {
          state: {
            billing:
              { ...values, tax, shipping: shippingChargeBasedOnSelectedShipMethod, certifications: certificationsCostBasedOnSelectedShipMethod, selectedShipMethod: fetchedQuoteDetails?.selectedShipMethod, subTotal: subTotal },
            part: saveQuote
          },
        });
      }
    } catch (err) {
      return err;
    }
  };

  // let handleCheckBox = () => {
  //   setCheck(!check);
  // };

  async function fetchData() {
    try {
      const response = await getAllAddress(token);
      setAllAddresses(response.data);
      let reversedData = response.data.reverse();
      const selectedAddress = reversedData[0];
      const lastTwo = [];
      if (selectedAddress) {
        console.log(selectedAddress);
        setValues((pre) => {
          return {
            ...pre, shippingAddress: selectedAddress?._id, addressline1: selectedAddress.addressLineOne,
            addressline2: selectedAddress.addressLineTwo,
            city: selectedAddress.city,
            country: selectedAddress.country,
            state: selectedAddress.state,
            zipCode: selectedAddress.postalCode
          }
        })
        lastTwo.push(selectedAddress);
        const secondAddress = reversedData.find((item) => item._id != selectedAddress?._id);
        secondAddress && lastTwo.push(secondAddress);
      }
      else {

        if (reversedData[0]) {
          lastTwo.push(reversedData[0]);
        }
        if (reversedData[1]) {
          lastTwo.push(reversedData[1]);
        }
      }


      // console.log("Address :",reversedData);
      // let lastTwo = reversedData.slice(0, 2);
      setRecentAddress(lastTwo);

    } catch (err) {
      console.log("Error In Fetch Data");
      return err;
    }
  }

  useEffect(() => {
    fetchData();
  }, [showAddressModal]);

  const fetchedQuoteDetailsById = async () => {
    try {
      const userId = getUserIdFromLocalStorage();
      let details = await fetchQuoteByIdForQuoteVersion(_id, token, userId);
      setFetchedQuoteDetails(details.data.data);
    } catch (err) {
      toast.error("Something went wrong while fetching quotes details.");
    }
  };
  console.log("Saved Quotation: ", fetchedQuoteDetails);
  useEffect(() => {
    const fetchDataAsync = async () => {

      try {

        let token = localStorage.getItem("Token");

        // console.log("TokenToken :", token);

        if (!token) {
          navigate("/");
          return;
        }

        let decode;
        try {
          decode = jwt_decode(token);
        } catch (error) {
          navigate("/");
          return;
        }

        if (!decode) {
          navigate("/");
          return;
        }

        if (decode.userType === "admin") {
          navigate("/admin");
          return;
        }

        if (decode.userType !== "user") {
          navigate("/");
          return;
        }
        // At this point, decode.userType === 'user', so proceed with the API calls and state setters
        setIsLoading(true);
        const data = await getProfileDetails(token);
        console.log("Data :", data);
        const profileData = {
          tax: data?.companySiteId?.taxes,
          vatNumber: data?.companySiteId?.vatNumber,
          firstName: data?.firstName,
          lastName: data?.lastName,
          mobileNumber: data?.phoneNumber || data?.companySiteId?.phoneNumber,
          email: data?.email,
          companyName: data?.companySiteId?.companyName,
          industry: data?.companySiteId?.companySite,
          userId: data?._id,
        };
        setProfileData(profileData);
        setTax(profileData.tax);
        setValues((values) => ({
          ...values,
          ...profileData,
        }));

        await fetchedQuoteDetailsById();
        await fetchData();

        if (location.state !== null) {
          setSaveQuote(location.state.part);
          setValues((values) => ({
            ...values,
            ...location.state.billing,
            firstName: fName,
            lastName: lName,
            email: usrEmail,
          }));
        } else {
          const response = await fetchQuoteById(_id, token);
          if (response.data.status !== true) {
            navigate("/saved-quote");
            toast.error("Details not found!");
            return;
          }

          const partsData = response.data.data.partsData;

          console.log('partsData', partsData)
          const selectedShipMethod = response.data.data.selectedShipMethod;
          console.log('selectedShipMethod', selectedShipMethod)



          const shippingCharge =
            selectedShipMethod === 1
              ? response.data.data.shippingCharge1
              : selectedShipMethod === 2
                ? response.data.data.shippingCharge2
                : response.data.data.shippingCharge3;
          setShippingChargeBasedOnSelectedShipMethod(shippingCharge);

          let totalValue = 0;

          if (response?.data?.data.orderCertificationsCost && response?.data?.data.orderCertificationsCost > 0) {
            setCertificationsCostBasedOnShipMethod(response?.data?.data.orderCertificationsCost);
          }

          partsData.forEach((el) => {
            const price = selectedShipMethod === 1 ? el.price1 : selectedShipMethod === 2 ? el.price2 : el.price3
            totalValue += ((price || 0) * (el.Qty || 0));
          });
          console.log("Calculated Total Cost :", totalValue);

          setSubTotal(totalValue);


          setValues((values) => ({
            ...values,
            ...profileData,
            quoteId: _id,
            firstName: fName,
            lastName: lName,
            email: usrEmail,
            companyName: response.data.data.userId.companySiteId?.companyName,
            industry:
              response?.data?.data?.userId?.companySiteId?.companySite,
            vatNumber: response?.data?.data?.userId?.companySiteId?.vatNumber,
          }));
          // }

          setSaveQuote(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDataAsync();
  }, []);

  const addNewBillingAddress = () => {
    setShowGenericAddressModal(true);
    seteditBillingAddressId(null);
  }
  const handleDeleteShareEmail = (item) => {
    let localEmailList = new Set(emailToShareQuote);
    localEmailList.delete(item);
    setEmailToShareQuote(localEmailList);
  };
  useDocumentTitle(saveQuote?.projectName || '');


  return (
    <div className="content-wrapper checkout-screen">
      <Header />
      {isLoading ? <Loading /> : ""}
      <Chat
        RefId={fetchedQuoteDetails?.RefId}
        open={open}
        onDrawerClose={onClose}
      />
      {showAddressModal && (
        <AddressModal
          addressModal={showAddressModal}
          setShowAddressModal={setShowAddressModal}
          setRecentAddress={setRecentAddress}
          recentAddress={recentAddress}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          _id={editId}
          userId={profileData.userId}
        />
      )}
      {showAddressList && (
        <AddressList
          showAddressList={showAddressList}
          error={error}
          setError={setError}
          setValues={setValues}
          values={values}
          setShowAddressList={setShowAddressList}
          setRecentAddress={setRecentAddress}
          recentAddress={recentAddress}
        />
      )}
      <GenericAddressListComponent
        show={showGenericAddressListModal}
        setShow={setShowGenericAddressListModal}
        allAddress={allBillingAddress}
        onAddAddressHandler={addNewBillingAddress}
        onDeleteHandler={deleteBilllingAddress}
        onEditHandler={(id) => {
          seteditBillingAddressId(id);
          setShowGenericAddressModal(true);
        }}
        setValues={setValues}
        values={values}





      />
      <GenericAddressComponent
        show={showGenericAddressModal}
        setShow={setShowGenericAddressModal}
        type="billing"
        userId={getUserIdFromLocalStorage()}
        onAddFunction={addBillingAddressFunction}
        editAddressId={editBillingAddressId}
        getAddressById={getBillingAddressByid}
        onUpdateFunction={billingAddressUpdateFunction}



      />
      <div
        className="top-section"
        style={{
          padding: 24,
          background: "#fff",
          position: "sticky",
          top: 64,
          zIndex: 10,
          border: "1px solid #e5e5e5"
        }}
      >
        <h6 className="info-text">Project Name</h6>
        <p className="sub-header">
          {
            saveQuote?.projectName?.length > 25 ?
              (saveQuote?.projectName)?.substring(0, 25) + "..."
              : saveQuote?.projectName
          }
        </p>
      </div>
      <div>
        <div className="sm-container">
          <div className="common-bx">

            <div className="order-pay-box">
              <p className="sub-header mb-2">Order & Pay</p>

              <div className="order-deatils-bx order-details-box">
                <Row>
                  <Col md={7}>
                    <div className="billing-box">
                      <p className="text">Billing Information</p>
                      <div className="billing-address-container">
                        <div className="billing-form">
                          <Row>
                            <div className="fieldsContainer">
                              <Col md={6}>
                                <div className="mb-3">
                                  <label>First Name</label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter First Name"
                                    value={values?.firstName}
                                    onChange={(e) => {
                                      setError({
                                        ...error,
                                        firstName: null,
                                      });
                                      setValues({
                                        ...values,
                                        firstName: e.target.value,
                                      });
                                    }}
                                  />
                                  {error.firstName && (
                                    <span className="error">
                                      {error.firstName}
                                    </span>
                                  )}
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="mb-3">
                                  <label>Last Name</label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter Last Name"
                                    value={
                                      values.lastName ? values.lastName : ""
                                    }
                                    onChange={(e) => {
                                      setError({
                                        ...error,
                                        lastName: null,
                                      });
                                      setValues({
                                        ...values,
                                        lastName: e.target.value,
                                      });
                                    }}
                                  />
                                  {error.lastName && (
                                    <span className="error">
                                      {error.lastName}
                                    </span>
                                  )}
                                </div>
                              </Col>
                            </div>
                            <div className="mobile">
                              <Col md={6}>
                                <div className="mb-3">
                                  <label>Email Address</label>
                                  <Form.Control
                                    type="email"
                                    placeholder="Enter Email Address"
                                    value={values.email}
                                    onChange={(e) => {
                                      setError({
                                        ...error,
                                        email: "",
                                      });
                                      setValues({
                                        ...values,
                                        email: e.target.value,
                                      });
                                    }}
                                  />
                                  {error.email && (
                                    <span className="error">{error.email}</span>
                                  )}
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <label>Mobile Number</label>
                                  <PhoneInput
                                    country={userCountry?.toLowerCase()}
                                    value={values?.mobileNumber}
                                    onChange={(value, data) => {
                                      setError({
                                        ...error,
                                        mobileNumber: null,
                                      });
                                      setValues({
                                        ...values,
                                        mobileNumber: value,
                                      });
                                    }}
                                  />
                                  {error.mobileNumber && (
                                    <span className="error">
                                      {error.mobileNumber}
                                    </span>
                                  )}
                                </div>
                              </Col>
                            </div>
                            <div className="company">
                              {userCompanyData && userCompanyData?.domain != '*' ? <Col md={3}>
                                <div className="mb-3">
                                  <label>Company Name</label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter Company Name"
                                    value={values?.companyName}
                                    onChange={(e) => {
                                      setError({
                                        ...error,
                                        companyName: null,
                                      });
                                      setValues({
                                        ...values,
                                        companyName: e.target.value,
                                      });
                                    }}
                                  />
                                  {error.companyName && (
                                    <span className="error">
                                      {error.companyName}
                                    </span>
                                  )}
                                </div>
                              </Col> : null}
                              {values?.industry?.length && userCompanyData && userCompanyData?.domain != '*' ? (
                                <Col md={3}>
                                  <div className="mb-3">
                                    <label>Site</label>
                                    <Form.Select
                                      name="cars"
                                      id="industry"
                                      className="industry"
                                    >
                                      {values?.industry?.map((el, id) => {
                                        return (
                                          <option value="industry" key={id}>
                                            {el}
                                          </option>
                                        );
                                      })}
                                    </Form.Select>
                                    {error.companyName && (
                                      <span className="error">
                                        {error.companyName}
                                      </span>
                                    )}
                                  </div>
                                </Col>
                              ) : null}

                              {userCompanyData && userCompanyData?.domain != '*' ? <Col md={3}>
                                <div className="mb-3">
                                  <label>Tax Number</label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter Tax Number"
                                    value={values.vatNumber}
                                    onChange={(e) => {
                                      setError({
                                        ...error,
                                        vatNumber: null,
                                      });
                                      setValues({
                                        ...values,
                                        vatNumber: e.target.value,
                                      });
                                    }}
                                  />
                                  {error.vatNumber && (
                                    <span className="error">
                                      {error.vatNumber}
                                    </span>
                                  )}
                                </div>
                              </Col> : null}
                            </div>
                          </Row>
                          <TailwindModalComponent />
                          <div className="address-bar mt-4">
                            <p className="text">Shipping address</p>
                            <div className="billing-form">
                              <div className="address">
                                {recentAddress.map((el, id) => (
                                  <div
                                    className="w-full my-2 flex items-center justify-between px-2 text-xs md:text-sm border py-1 address-box"
                                    key={id}
                                  >
                                    <div className="flex  items-center">
                                      <input
                                        className="btn-radio"
                                        type="radio"
                                        value={el._id}
                                        checked={
                                          values.shippingAddress == el._id
                                        }
                                        name="rd"
                                        style={{ marginRight: "12px" }}
                                        onChange={(e) => {
                                          setError({
                                            ...error,
                                            shippingAddress: "",
                                          });
                                          setValues({
                                            ...values,
                                            shippingAddress: el._id,
                                            addressline1: el.addressLineOne,
                                            addressline2: el.addressLineTwo,
                                            city: el.city,
                                            country: el.country,
                                            state: el.state,
                                            zipCode: el.postalCode,
                                          });
                                        }}
                                      />
                                      <div className="address text-gray-500 font-medium text-xs">
                                        <p className="text mb-1">
                                          {el?.firstName} {el?.lastName || ""}
                                        </p>
                                        <div className="add">
                                          {el?.addressLineOne}{" "}
                                          {el?.addressLineTwo} {el?.city}{" "}
                                          {el?.state} {el.postalCode}{" "}
                                          {el.country}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex gap-x-2">
                                      <div
                                        className="flex    text-slate-500  text-sm px-1 py-1 mx-1 justify-center  items-center gap-x-1"
                                        onClick={() => editHandler(el._id)}
                                      >
                                        <EditIcon additionalClass="!h-4 cursor-pointer" />
                                      </div>
                                      <div
                                        className="flex justify-center  items-center text-red-500  text-sm px-2 py-1 gap-x-1"
                                        onClick={() => {
                                          AntModal.confirm({
                                            title: 'Confirm',
                                            content: 'Are you sure?',
                                            okText: 'Yes',
                                            cancelText: 'No',
                                            onOk() {
                                              deleteData(el._id)
                                            },
                                            onCancel() {
                                              console.log('Cancel');
                                            }
                                          });
                                          // deleteData(el._id)
                                        }}
                                      >
                                        <DeleteIcon additionalClass="!h-4 cursor-pointer" />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                {error.shippingAddress && (
                                  <span className="error">
                                    {error.shippingAddress}
                                  </span>
                                )}
                                <div className="w-full flex  px-2 py-1 justify-between">
                                  {allAddresses?.length == 0 ? (
                                    <div
                                      style={{
                                        cursor: "auto",
                                        textDecoration: "none",
                                        opacity: "0.7",
                                      }}
                                      className="text"
                                    >
                                      No Addresses available
                                    </div>
                                  ) : (
                                    <button
                                      onClick={showAddressListHandler}
                                      className="link-btn"
                                    >
                                      See all address
                                    </button>
                                  )}
                                  {allAddresses?.length >= 5 ? (
                                    <button
                                      style={{ cursor: "auto", opacity: "0.5" }}
                                      className="link-btn"
                                    >
                                      + Add New Address
                                    </button>
                                  ) : (
                                    <button
                                      // className="addNew"
                                      onClick={addNewHandler}
                                      className="link-btn"
                                    >
                                      + Add New Address
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="address-bar mt-4">
                            <p className="text">Billing address</p>
                            <div className="billing-form">
                              <div className="address">
                                {recentBillingAddress.map((el, id) => (
                                  <div
                                    className="w-full my-2 flex items-center justify-between px-2 text-xs md:text-sm border py-1 address-box"
                                    key={id}
                                  >
                                    <div className="flex  items-center">
                                      <input
                                        className="btn-radio"
                                        type="radio"
                                        value={el._id}
                                        checked={
                                          values.billingAddress == el._id
                                        }
                                        name="billing"
                                        style={{ marginRight: "12px" }}
                                        onChange={(e) => {
                                          setError({
                                            ...error,
                                            billingAddress: "",
                                          });
                                          setValues({
                                            ...values,
                                            billingAddress: el._id,
                                          });
                                        }}
                                      />
                                      <div className="address text-gray-500 font-medium text-xs">
                                        <p className="text mb-1">
                                          {el?.firstName} {el?.lastName || ""}
                                        </p>
                                        <div className="add">
                                          {el?.addressLineOne}{" "}
                                          {el?.addressLineTwo} {el?.city}{" "}
                                          {el?.state} {el.postalCode}{" "}
                                          {el.country}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex gap-x-2">
                                      <div
                                        className="flex    text-slate-500  text-sm px-1 py-1 mx-1 justify-center  items-center gap-x-1"
                                        onClick={() => {
                                          seteditBillingAddressId(el._id);
                                          setShowGenericAddressModal(true);
                                        }}
                                      >
                                        <EditIcon additionalClass="!h-4 cursor-pointer" />
                                      </div>
                                      <div
                                        className="flex justify-center  items-center text-red-500  text-sm px-2 py-1 gap-x-1"
                                        onClick={() => {

                                          AntModal.confirm({
                                            title: 'Confirm',
                                            content: 'Are you sure?',
                                            okText: 'Yes',
                                            cancelText: 'No',
                                            onOk() {
                                              deleteBilllingAddress(el._id)
                                            },
                                            onCancel() {
                                              console.log('Cancel');
                                            }
                                          });
                                        }}
                                      >
                                        <DeleteIcon additionalClass="!h-4 cursor-pointer" />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                {error.billingAddress && (
                                  <span className="error">
                                    {error.billingAddress}
                                  </span>
                                )}
                                <div className="w-full flex  px-2 py-1 justify-between">
                                  {allBillingAddress?.length == 0 ? (
                                    <div
                                      style={{
                                        cursor: "auto",
                                        textDecoration: "none",
                                        opacity: "0.7",
                                      }}
                                      className="text"
                                    >
                                      No Addresses available
                                    </div>
                                  ) : (
                                    <button
                                      onClick={handleSeeAllAddressClick}
                                      className="link-btn"
                                    >
                                      See all address
                                    </button>
                                  )}
                                  {allBillingAddress?.length >= 5 ? (
                                    <button
                                      style={{ cursor: "auto", opacity: "0.5" }}
                                      className="link-btn"
                                    >
                                      + Add New Address
                                    </button>
                                  ) : (
                                    <button
                                      // className="addNew"
                                      onClick={addNewBillingAddress}
                                      className="link-btn"
                                    >
                                      + Add New Address
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={5}>
                    <div className="quote-right">
                      <div className="qoute-box">
                        <p className="text flex items-center gap-x-2 mb-4">
                          Quotation Summary{" "}
                          {(fetchedQuoteDetails?.RefId != null && fetchedQuoteDetails?.version != null) ? <span style={{ display: "flex", fontSize: "13px" }}>
                            (
                            {fetchedQuoteDetails?.RefId +
                              " V-" +
                              fetchedQuoteDetails?.version}
                            )
                          </span> : null}
                        </p>
                        <div className="pd-items">
                          {fetchedQuoteDetails?.selectedProcess <= 2 ? (
                            fetchedQuoteDetails &&
                              fetchedQuoteDetails.partsData &&
                              fetchedQuoteDetails?.partsData?.length ? (
                              fetchedQuoteDetails?.partsData.map((val, i) => {
                                return (
                                  <div className="item-box" key={i}>
                                    <div className=" grid md:grid-cols-2 grid-col-1 my-2 gap-x-2">
                                      <div className="flex gap-x-2 flex-wrap">
                                        {val?.thumbnail ? <img
                                          className="h-12 border border-gray-300"
                                          src={val?.thumbnail}
                                        /> : null}
                                        <span
                                          className="qt-text"
                                          style={{
                                            wordWrap: "break-word",
                                            wordBreak: "break-all",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {(
                                            val?.selectedFile?.originalname ||
                                            "No File Uploaded"
                                          )?.length > 15
                                            ? val?.selectedFile?.originalname.substring(
                                              0,
                                              15
                                            ) + "..."
                                            : val?.selectedFile?.originalname ||
                                            "No File Uploaded"}
                                          <p className="info-text">
                                            {saveQuote?.selectedProcess &&
                                              processType.map((val, i) => {
                                                if (
                                                  val.id ==
                                                  saveQuote.selectedProcess
                                                ) {
                                                  return val.name;
                                                }
                                              })}
                                          </p>
                                        </span>
                                      </div>
                                      <div className="  grid grid-cols-2   w-full  justify-items-end text-end gap-x-2 text-sm ">
                                        <div className="flex item-center justify-center gap-1">(
                                          <p className="text">{currencyFormatter(
                                            saveQuote?.selectedShipMethod === 1
                                              ? (
                                                parseFloat(val?.price1)
                                              ).toFixed(2)
                                              : saveQuote?.selectedShipMethod ===
                                                2
                                                ? (
                                                  parseFloat(val?.price2)
                                                ).toFixed(2)
                                                : saveQuote?.selectedShipMethod ===
                                                  3
                                                  ? (
                                                    parseFloat(val?.price3)
                                                  ).toFixed(2)
                                                  : 0
                                          )}</p>
                                          <p className="text">x</p>
                                          <p className="text">{val?.Qty}</p>
                                          )
                                        </div>

                                        <span className="text"><b>{currencyFormatter(
                                          saveQuote?.selectedShipMethod === 1
                                            ? (
                                              parseFloat(val?.price1) * Number(val?.Qty)
                                            ).toFixed(2)
                                            : saveQuote?.selectedShipMethod ===
                                              2
                                              ? (
                                                parseFloat(val?.price2) * Number(val?.Qty)
                                              ).toFixed(2)
                                              : saveQuote?.selectedShipMethod ===
                                                3
                                                ? (
                                                  parseFloat(val?.price3) * Number(val?.Qty)
                                                ).toFixed(2)
                                                : 0
                                        )}</b></span>
                                      </div>
                                    </div>
                                    {/* {console.log("Selected Process :", fetchedQuoteDetails.selectedProcess)} */}
                                    {/* {console.log("FetchedQuoteDetails", fetchedQuoteDetails)} */}
                                    <div className="desc-part-quote-version quote-summary">
                                      {fetchedQuoteDetails.selectedProcess == 1 ?
                                        <Fragment>
                                          {val?.description ? (
                                            <li><span>Description :</span><span>{val?.description}</span></li>
                                          ) : (
                                            ""
                                          )}
                                          {val?.cncMaterial ? (
                                            <li> <span>Material :</span><span>{val?.cncMaterial?.cnc_material}</span></li>
                                          ) : (
                                            ""
                                          )}
                                          {val?.cncMaterial ? (
                                            <li> <span>Grade :</span><span>{val?.cncMaterial?.cnc_grade}</span></li>
                                          ) : (
                                            ""
                                          )}
                                          {val?.cncSurfaceFinish ? (
                                            <li><span>Finish :</span><span>{val?.cncSurfaceFinish.cnc_surface_finish}</span></li>
                                          ) : (
                                            ""
                                          )}
                                          {val?.cncHeatTreatment ? (
                                            <li><span>Treatment :</span><span>{val?.cncHeatTreatment.cnc_heat_treatment}</span></li>
                                          ) : (
                                            ""
                                          )}
                                          {val?.cncTolerance ? (
                                            <li><span>Tolerance :</span><span>{val?.cncTolerance.cnc_tolerance}</span></li>
                                          ) : (
                                            ""
                                          )}
                                          {val?.cncPartMarking ? (
                                            <li><span>Marking :</span><span>{val?.cncPartMarking.cnc_part_marking ? "Yes" : "No"}</span></li>
                                          ) : (
                                            ""
                                          )}
                                        </Fragment>
                                        :
                                        <>
                                          <li>
                                            {val.threeDTechnology &&
                                              val.threeDTechnology?.name
                                            }
                                          </li>
                                          {/* <li>
                                            {val.threeDMachine &&
                                              val.threeDMachine?.name
                                            }
                                          </li> */}
                                          <li>
                                            {val.threeDMaterial &&
                                              val.threeDMaterial?.name
                                            }
                                          </li>
                                          <li>
                                            {val.threeDPostProcessing &&
                                              val.threeDPostProcessing?.name
                                            }
                                          </li>
                                        </>}
                                      {(val.XDimensionValue && val.YDimensionValue && val.ZDimensionValue) ? (
                                        <Fragment>
                                          <li>
                                            {`${val.XDimensionValue} x ${val.YDimensionValue} x ${val.ZDimensionValue} (mm) / ${(val.XDimensionValue / miliMeterToInchFactor).toFixed(2)} x ${(val.YDimensionValue / miliMeterToInchFactor).toFixed(2)} x ${(val.ZDimensionValue / miliMeterToInchFactor).toFixed(2)} (inches)`}
                                          </li>
                                          <li>
                                            Volume : {val?.partVolume?.toFixed(2)} cc
                                          </li>
                                        </Fragment>
                                      ) : ""}
                                    </div>
                                    <p></p>
                                  </div>
                                );
                              })
                            ) : (
                              ""
                            )
                          ) : saveQuote.selectedProcess >= 3 ? (
                            saveQuote &&
                              saveQuote.partsData &&
                              saveQuote?.partsData?.length ? (
                              saveQuote?.partsData.map((val, i) => {
                                return (
                                  <div className="item-box" key={i}>
                                    <div className="item-bar">
                                      <div className="left">
                                        <span className="img-box"></span>
                                        <span className="qt-text">
                                          {(
                                            val?.selectedFile?.originalname ||
                                            val.linePartName ||
                                            "No File Uploaded"
                                          )?.length > 25
                                            ? (
                                              val?.selectedFile?.originalname ||
                                              val.linePartName ||
                                              "No File Uploaded"
                                            ).substring(0, 25) + "..."
                                            : val?.selectedFile?.originalname ||
                                            val.linePartName ||
                                            "No File Uploaded"}
                                          <p>
                                            {saveQuote?.selectedProcess &&
                                              processType.map((item, i) => {
                                                if (
                                                  item.id ==
                                                  saveQuote.selectedProcess
                                                ) {
                                                  return item.name;
                                                }
                                              })}
                                          </p>
                                        </span>
                                      </div>
                                      <div className="right">
                                        {currencyFormatter(
                                          saveQuote?.selectedShipMethod === 1
                                            ? (
                                              parseFloat(val?.price1)
                                            ).toFixed(2)
                                            : saveQuote?.selectedShipMethod ===
                                              2
                                              ? (
                                                parseFloat(val?.price2)
                                              ).toFixed(2)
                                              : saveQuote?.selectedShipMethod ===
                                                3
                                                ? (
                                                  parseFloat(val?.price3)
                                                ).toFixed(2)
                                                : 0
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className="desc-part-quote-version"
                                      style={{
                                        textAlign: "left",
                                        wordWrap: "break-word",
                                        wordBreak: "break-all",
                                        whiteSpace: "normal",
                                        width: "100%",
                                      }}
                                    >
                                      <ul>
                                        {val?.description ? (
                                          <li>{val?.description}</li>
                                        ) : (
                                          ""
                                        )}
                                        {val?.Notes ? (
                                          <li>{val?.Notes}</li>
                                        ) : (
                                          ""
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              ""
                            )
                          ) : (
                            <></>
                          )}


                          {fetchedQuoteDetails?.orderCertificationsCost ? <div className="item-box">
                            <div
                              className="item-bar"
                              style={{ marginBottom: "0px" }}
                            >
                              <div className="left">
                                <span className="qt-text pl-0">
                                  <h6>Certifications : </h6>
                                </span>
                              </div>
                              <div className="right">
                                {currencyFormatter(fetchedQuoteDetails?.orderCertificationsCost)}
                              </div>
                            </div>
                          </div> : null}

                          <div className="item-box">
                            <div
                              className="item-bar"
                              style={{ marginBottom: "0px" }}
                            >
                              <div className="left">
                                <span className="qt-text pl-0">
                                  <p className="text">Shipping :- {" "} {fetchedQuoteDetails?.selectedShipMethod == 1
                                    ? `${fetchedQuoteDetails?.shippingDays1 ? fetchedQuoteDetails?.shippingDays1 : ""} business days`
                                    : fetchedQuoteDetails?.selectedShipMethod == 2
                                      ? `${fetchedQuoteDetails?.shippingDays2 ? fetchedQuoteDetails?.shippingDays2 : ""} business days`
                                      : `${fetchedQuoteDetails?.shippingDays3 ? fetchedQuoteDetails?.shippingDays3 : ""} business days`}</p>
                                </span>
                              </div>
                              <p className="right text">
                                {fetchedQuoteDetails &&
                                  typeof fetchedQuoteDetails.selectedShipMethod === "number" &&
                                  (
                                    fetchedQuoteDetails.selectedShipMethod === 1
                                      ? fetchedQuoteDetails.shippingCharge1
                                      : fetchedQuoteDetails.selectedShipMethod === 2
                                        ? fetchedQuoteDetails.shippingCharge2
                                        : fetchedQuoteDetails.shippingCharge3
                                  ) != null ? (
                                  currencyFormatter(
                                    fetchedQuoteDetails.selectedShipMethod === 1
                                      ? fetchedQuoteDetails.shippingCharge1
                                      : fetchedQuoteDetails.selectedShipMethod === 2
                                        ? fetchedQuoteDetails.shippingCharge2
                                        : fetchedQuoteDetails.shippingCharge3
                                  )
                                ) : (
                                  ""
                                )}
                              </p>

                            </div>
                          </div>

                          <div className="item-box">
                            <div className="item-bar">
                              <div className="left">
                                <span className="qt-text pl-0">
                                  <p className="text">
                                    Lead time  :-{" "}
                                    {fetchedQuoteDetails?.selectedShipMethod == 1
                                      ? `${fetchedQuoteDetails?.leadTime1 ? fetchedQuoteDetails?.leadTime1 : ""} business days`
                                      : fetchedQuoteDetails?.selectedShipMethod == 2
                                        ? `${fetchedQuoteDetails?.leadTime2 ? fetchedQuoteDetails?.leadTime2 : ""} business days`
                                        : `${fetchedQuoteDetails?.leadTime3 ? fetchedQuoteDetails?.leadTime3 : ""} business days`}
                                  </p>

                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="subtotal-bx">
                            <ul>
                              <li>
                                <span>Subtotal </span>{" "}
                                <span>
                                  {currencyFormatter(subTotal + shippingChargeBasedOnSelectedShipMethod + certificationsCostBasedOnSelectedShipMethod)

                                  }
                                </span>{" "}
                              </li>
                              <li>
                                <span>Taxes ({tax}%)</span>{" "}
                                <span>
                                  {tax > 0
                                    ? currencyFormatter(
                                      (
                                        (subTotal + shippingChargeBasedOnSelectedShipMethod + certificationsCostBasedOnSelectedShipMethod) *
                                        (tax / 100)
                                      )
                                    )
                                    : ""}
                                </span>{" "}
                              </li>

                            </ul>
                          </div>
                        </div>
                        <div className="total-amt pt-2">
                          <p className="text"><b>Total</b></p>
                          <p className="text">
                            <b>
                              {currencyFormatter(
                                (
                                  subTotal +
                                  shippingChargeBasedOnSelectedShipMethod +
                                  certificationsCostBasedOnSelectedShipMethod +
                                  (
                                    tax > 0
                                      ? (subTotal + shippingChargeBasedOnSelectedShipMethod + certificationsCostBasedOnSelectedShipMethod) * (tax / 100)
                                      : 0
                                  )
                                ).toFixed(2)
                              )}
                            </b>
                          </p>
                        </div>

                      </div>
                      <div className="check-sub">

                        <p className="flex gap-x-2 items-center mt-2 mb-3">
                          <InfoIcon />
                          <span className="text text-red-400">
                            This quote is now saved in Saved Quotes
                          </span>
                        </p>
                        <div className="price-box">
                          <div className="button-bx">
                            {" "}
                            {!fetchedQuoteDetails?.myorders ?
                              <button
                                className="primary-btn w-100"
                                onClick={() => handleSubmit()}
                              >
                                <span>Submit and Proceed</span>
                              </button> : <button
                                className="bg-gray-300 text-white rounded h-9 w-100"
                                
                              >
                                <span>Order already created</span>
                                </button>}


                            <div className="my-2  flex h-10 gap-x-2  ">
                              <span className="grow flex justify-center items-center" onClick={showDrawer}>
                                <ChatButton
                                  RefId={fetchedQuoteDetails?.RefId}
                                  showDrawer={showDrawer}
                                  additionalClass={'border-btn chat-border-btn'}
                                />
                              </span>
                              <Link
                                to="#"
                                className="border-btn w-50"
                                onClick={handleShareQuoteModalOpen}
                              >
                                <ShareIcon />
                                <span>Share</span>
                              </Link>
                            </div>
                          </div>
                          <div className="btm-buttons"></div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            {/* upload requirement close */}
          </div>

        </div>
      </div>

      {/* address list popup */}

      <Modal show={showA} onHide={handleOneClose} className="address-pop">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "15px" }}>
            All Addresses <span>(15)</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="address-sl">
            <h5>Select Address</h5>
            <div className="address-list-in">
              <div className="ad-box">
                <div className="rd-left rd-box">
                  <input type="radio" id="testA" name="radio-group" checked />
                  <label htmlFor="testA"></label>
                </div>
                <div className="ad-text">
                  <div className="name">John Cena</div>
                  <p>
                    A/504, ShreeHari Complex, Teesgaonpada, Near Ashok School,
                    Kalyan, Maharashtra 421306, India
                  </p>
                </div>
                <div className="action-text">
                  <ul>
                    <li>
                      {" "}
                      <Link to="">Edit</Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="">Remove</Link>{" "}
                    </li>
                  </ul>
                </div>
              </div>

              <div className="ad-box">
                <div className="rd-left rd-box">
                  <input type="radio" id="testB" name="radio-group" checked />
                  <label htmlFor="testB"></label>
                </div>
                <div className="ad-text">
                  <div className="name">John Cena</div>
                  <p>
                    A/504, ShreeHari Complex, Teesgaonpada, Near Ashok School,
                    Kalyan, Maharashtra 421306, India
                  </p>
                </div>
                <div className="action-text">
                  <ul>
                    <li>
                      {" "}
                      <Link to="">Edit</Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="">Remove</Link>{" "}
                    </li>
                  </ul>
                </div>
              </div>

              <div className="ad-box">
                <div className="rd-left rd-box">
                  <input type="radio" id="testC" name="radio-group" checked />
                  <label htmlFor="testC"></label>
                </div>
                <div className="ad-text">
                  <div className="name">John Cena</div>
                  <p>
                    A/504, ShreeHari Complex, Teesgaonpada, Near Ashok School,
                    Kalyan, Maharashtra 421306, India
                  </p>
                </div>
                <div className="action-text">
                  <ul>
                    <li>
                      {" "}
                      <Link to="">Edit</Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="">Remove</Link>{" "}
                    </li>
                  </ul>
                </div>
              </div>

              <div className="ad-box">
                <div className="rd-left rd-box">
                  <input type="radio" id="testD" name="radio-group" checked />
                  <label htmlFor="testD"></label>
                </div>
                <div className="ad-text">
                  <div className="name">John Cena</div>
                  <p>
                    A/504, ShreeHari Complex, Teesgaonpada, Near Ashok School,
                    Kalyan, Maharashtra 421306, India
                  </p>
                </div>
                <div className="action-text">
                  <ul>
                    <li>
                      {" "}
                      <Link to="">Edit</Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="">Remove</Link>{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="foot-left">
            {" "}
            <Link to="">+ Add New Address</Link>{" "}
          </div>
          <div className="foot-right">
            <Button onClick={handleOneClose} className="submit-btn">
              Done
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* address list popup close */}

      {/* add address popup */}

      {/* add address popup close */}

      {/* Share quote modal */}
      <Modal
        size="sm"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={shareQuoteModalShow}
        onHide={handleShareQuoteClose}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
          >
            Share Quotation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="share-quote-div">
            <h6 className="">
              Emails entered below will receive an email with Quotation details
              in their mailbox.
            </h6>
            <div className="add-email-div my-2  p-2">
              <input
                placeholder="Enter the email to share the quotation details"
                value={inputEmail}
                onChange={(e) => setInputEmail(e.target.value)}
                className="border me-2 !rounded-none"
              />
              <button onClick={handleAddButtonToReceiverList}>
                + Add Email
              </button>
            </div>
            <div className="share-content-div">
              <h6>Receiver's List</h6>
              <div className="email-list-share-div">
                {emailToShareQuote.size > 0
                  ? Array.from(emailToShareQuote).map((item, index) => {
                    return (
                      <span className="email-item" key={index}>
                        {item}{" "}
                        <img
                          src={closeImg}
                          className="close-img"
                          onClick={(e) => handleDeleteShareEmail(item)}
                        />
                      </span>
                    );
                  })
                  : null}
              </div>
            </div>
          </div>
          {shareQuoteError ? <div className={`mt-4 my-2 flex items-center space-x-2 bg-orange-100 border border-orange-300 text-orange-800 rounded-md px-3 py-2`}>

            <CircleAlertDFM
              additionalClasses={'!h-4'}
            />
            <span className="font-medium">{shareQuoteError}</span>
          </div> : null}
        </Modal.Body>
        <Modal.Footer>
          <div className="share-quote-div-footer">
            <div className="share-button" onClick={handleQuotationShare}>
              Share
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default StepThree;
